import { listIdTypes } from "@/api/modules/customerid";

const IdentificationType = function(
    id,
    displayNameDanish,
    displayNameEnglish,
    displayNameGerman,
    numberOfControlDigits,
    useDigitsFromEnd
) {
    this.id = id;
    this.texts = {
        da: displayNameDanish,
        en: displayNameEnglish,
        de: displayNameGerman
    };
    this.numberOfControlDigits = numberOfControlDigits;
    this.useDigitsFromEnd = useDigitsFromEnd;
};

export const state = {
    identificationTypes: []
};

export const mutations = {
    setIdentificationTypes: (state, identificationTypes) => {
        state.identificationTypes = identificationTypes;
    }
};

export const getters = {
    getIdentificationTypes: state => {
        return state.identificationTypes;
    },
    getIdentificationTypeFromId: state => {
        return id =>
            state.identificationTypes.filter(item => item.id === id)[0];
    }
};

export const actions = {
    updateIdentificationTypes: context => {
        return listIdTypes(false)
            .then(response => {
                if (!response.ok) {
                    throw new Error(JSON.stringify(response));
                }

                return response.responseBody;
            })
            .then(response => {
                context.commit(
                    "setIdentificationTypes",
                    response.types.map(item => {
                        return new IdentificationType(
                            item.id,
                            item.nameDanish,
                            item.nameEnglish,
                            item.nameGerman,
                            item.numCharactersRequired,
                            item.useCharactersFromEnd
                        );
                    })
                );
            });
    }
};
